module.exports = __webpack_public_path__ + "img/1236567443.dd240fe4.jpg";